import styles from '../centralAntrag.module.css';
// import stylesFlex from './flexkarteBestellen.module.css';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { geschlecht, sportangebote, month, beitrag, addBeitrag, beteiligung, evaluation, accept } from '../../../../../config/meta-informationen';
import { showErrorToast } from '../../../../../code/ToastHelper';
import { isValidIban, createYears } from '../code';
function Mitgliedschaftantrag() {
    const navigate = useNavigate();
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, '0')}.${String(today.getMonth() + 1).padStart(2, '0')}.${today.getFullYear()}`;
    const [formData, setFormData] = useState({
        formType: "orderMitgliedschaft",
        dateToday: formattedDate,
        firstName: "",
        familyName: "",
        birthdate: "",
        sex: "",
        telefon: "",
        email: "",
        street: "",
        housenumber: "",
        zusatz: "",
        plz: "",
        area: "",
        month: "",
        year: "",
        sportoffer: "",
        beitrag: "",
        addBeitrag: "",
        bemerkung: "",
        accountholder: "",
        iban: "",
        noticed: "",
        dataSecurity: "",
        bereich: "",
        ideen: "",
        einverstaendnisOeffentlichkeit: "",
        gesundheitJugendfussball: "",
        evaluation: "",
        anderes: ""
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!/^\d{5}$/.test(formData['plz'])) {
            const plzInput = document.querySelector('input[name="plz"]');
            if (plzInput) {
                plzInput.focus();
                plzInput.classList.add('error');
            }
            return;
        }
        if (!isValidIban(formData['iban'])) {
            const ibanInput = document.querySelector('input[name="iban"]');
            if (ibanInput) {
                ibanInput.focus();
                ibanInput.classList.add('error');
            }
            return;
        }

        setLoading(true);
        try {
            const response = await fetch("/api/email/send-emails", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (response.ok) {
                setSubmitted(true);
            } else {
                showErrorToast("Fehler beim Senden: " + result.message);
            }
        } catch (error) {
            console.error("Ein Fehler ist aufgetreten:", error);
            showErrorToast("Beim Senden der Anfrage ist ein Fehler aufgetreten.");
        }
        setLoading(false)
    };


    const years = createYears();
    return (
        <section className={styles.container}>
            <h1>Antrag auf TuS-Mitgliedschaft</h1>

            {!submitted ? (
                <form className={styles.formular} onSubmit={handleSubmit}>
                    {/* Allgemeine Informationen */}
                    <div className={styles.section}>
                        <p className={styles.sectionTitle}>Allgemeine Informationen</p>
                        <div className={styles.area}>
                            <label>
                                <div>Vorname<span className={styles.required}>*</span></div>
                                <input type="text" name="firstName" placeholder='Max' required onChange={handleChange} />
                            </label>
                            <label>
                                <div>Nachname<span className={styles.required}>*</span></div>
                                <input type="text" name="familyName" placeholder='Mustermann' required onChange={handleChange} />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>Geburtsdatum<span className={styles.required}>*</span></div>
                                <input type="date" name="birthdate" required onChange={handleChange} />
                            </label>
                            <label>
                                <div>Geschlecht<span className={styles.required}>*</span></div>
                                <select
                                    name="sex"
                                    value={formData.sex}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="" disabled>Wähle dein Geschlecht...</option>
                                    {Object.keys(geschlecht).map((key) => (
                                        <option key={key} value={geschlecht[key]}>
                                            {geschlecht[key]}
                                        </option>
                                    ))}
                                </select>
                            </label>
                            <label>
                                <div>Telefonnummer<span className={styles.required}>*</span></div>
                                <input type="tel" name="telefon" placeholder='0177123456789' required onChange={handleChange} />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>E-Mail<span className={styles.required}>*</span></div>
                                <input type="email" name="email" placeholder='max.mustermann@muster-adresse.de' required onChange={handleChange} />
                            </label>
                        </div>
                    </div>
                    {/* Adresse */}
                    <div className={styles.section}>
                        <p className={styles.sectionTitle}>Adresse</p>
                        <div className={styles.area}>
                            <label className={styles.big}>
                                <div>Straße<span className={styles.required}>*</span></div>
                                <input type="text" name="street" placeholder='Musterstraße' required onChange={handleChange} />
                            </label>
                            <label className={styles.small}>
                                <div>Hausnummer<span className={styles.required}>*</span></div>
                                <input type="text" name="housenumber" placeholder='3a' required onChange={handleChange} />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>Zusatz</div>
                                <input type="text" name="zusatz" placeholder='Hinterhof' onChange={handleChange} />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label className={styles.small}>
                                <div>PLZ<span className={styles.required}>*</span></div>
                                <input type="text" name="plz" placeholder='53639' pattern="\d{5}" required onChange={handleChange}
                                    maxLength={5}
                                    inputMode="numeric"
                                    title="Bitte eine fünfstellige Postleitzahl eingeben"
                                />
                            </label>
                            <label className={styles.big}>
                                <div>Ort<span className={styles.required}>*</span></div>
                                <input type="text" name="area" placeholder='Königswinter' required onChange={handleChange} />
                            </label>

                        </div>
                    </div>
                    {/* Auswahl Mitgliedschaft */}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>Auswahl Mitgliedschaft</p>
                            <p className={styles.subTitle}>Beitritt zum 01. eines jeden Monat im Jahr möglich</p>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>Monat<span className={styles.required}>*</span></div>
                                <select
                                    name="month"
                                    value={formData.month}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="" disabled>Wähle den Monat...</option>
                                    {Object.keys(month).map((key) => (
                                        <option key={key} value={key}>
                                            {month[key]}
                                        </option>
                                    ))}
                                </select>
                            </label>
                            <label >
                                <div>Jahr<span className={styles.required}>*</span></div>
                                <select
                                    name="year"
                                    value={formData.year}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="" disabled>Wähle das Jahr...</option>
                                    {Object.keys(years).map((key) => (
                                        <option key={key} value={key}>
                                            {years[key]}
                                        </option>
                                    ))}
                                </select>
                            </label>
                            <label >
                                <div>Sportangebote</div>
                                <select
                                    name="sportoffer"
                                    value={formData.sportoffer}
                                    onChange={handleChange}
                                >
                                    <option value="" disabled>Wähle ein Sportangebot...</option>
                                    {Object.keys(sportangebote).map((key) => (
                                        <option key={key} value={key}>
                                            {sportangebote[key]}
                                        </option>
                                    ))}
                                </select>
                            </label>
                        </div>
                        <div className={styles.beitrag}>
                            <label>
                                <div>Beitrag<span className={styles.required}>*</span></div>
                                <select
                                    name="beitrag"
                                    value={formData.beitrag}
                                    onChange={handleChange}
                                >
                                    <option value="" disabled>Wähle eine Beitragsart...</option>
                                    {Object.entries(beitrag).map(([key, info]) => {
                                        const labelText = `${info.label}${info.priceMonth ? ` - ${info.priceMonth}` : ""}${info.priceYear ? ` ${info.priceYear}` : ""}`;

                                        return (
                                            <option key={key} value={labelText}>
                                                {labelText}
                                            </option>
                                        );
                                    })}
                                </select>
                            </label>
                            <label>
                                <div>Zusatzbeitrag<span className={styles.required}>*</span></div>
                                <select
                                    name="addBeitrag"
                                    value={formData.addBeitrag}
                                    onChange={handleChange}
                                >
                                    <option value="" disabled>Wähle einen Zusatzbeitrag...</option>
                                    {Object.entries(addBeitrag).map(([key, info]) => {
                                        const labelText = `${info.label}${info.priceMonth ? ` - ${info.priceMonth}` : ""}${info.priceYear ? ` ${info.priceYear}` : ""}`;

                                        return (
                                            <option key={key} value={labelText}>
                                                {labelText}
                                            </option>
                                        );
                                    })}
                                </select>
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>Bemerkungen</div>
                                <textarea name="bemerkung" placeholder="Hinweis auf bestehende Einzelmitgliedschaft, Wunsch nach Wechsel auf Familienmitgliedschaft" onChange={handleChange}></textarea>
                            </label>
                        </div>

                    </div>
                    {/* SEPA-Lastschriftmandat */}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>SEPA-Lastschriftmandat</p>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>Kontoinhaber<span className={styles.required}>*</span></div>
                                <input type="text" name="accountholder" placeholder='Max Mustermann' required onChange={handleChange} />
                            </label>
                            <label>
                                <div>IBAN<span className={styles.required}>*</span></div>
                                <input type="text" name="iban" placeholder='0123456789' required onChange={handleChange}
                                    inputMode="text"
                                    title="Bitte eine gültige IBAN eingeben (z.B. DE01 2345 6789 0123 4567 89)"
                                />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <div className={styles.areaSpecial}>
                                <p>Ich nehme zur Kenntnis, dass anfallende Gebühren bei Nichteinlösung des SEPA-Lastschriftmandats in vollen Umfang zu meinen Lasten gehen.</p>
                                <label>
                                    <div>Kenntnisnahme:</div>
                                    <div><input type="checkbox" name="noticed" required onChange={handleChange} /><span className={styles.required}>*</span></div>

                                </label>
                            </div>
                        </div>
                    </div>
                    {/* Datenschutzhinweis */}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>Datenschutzhinweis</p>
                        </div>
                        <div className={styles.area}>
                            <div className={styles.areaSpecial}>
                                <p>Ich habe die sich auf der Homepage des Vereins (tus05-oberpleis.de) befindlichen Datenschutzhinweis gelesen und erkläre mich hiermit einverstanden. Sie können Ihre erteilte Einwilligung jederzeit mit Wirkung für die Zukunft gem. Art. 7 Abs. 3 DSGVO widerrufen. Ebenso können Sie der künftigen Verarbeitung der Sie betreffenden Daten nach Maßgabe des Art. 21 DSGVO jederzeit widersprechen: <span tabIndex={0} onClick={() => { navigate("/datenschutz") }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {

                                            e.preventDefault(); // Prevent space from scrolling
                                            navigate("/datenschutz")
                                        }
                                    }}>Datenschutzerklärung</span></p>
                                <label>
                                    <div>Ich stimme der Datenschutzerklärung zu:</div>
                                    <div><input type="checkbox" name="dataSecurity" required onChange={handleChange} /><span className={styles.required}>*</span></div>

                                </label>
                            </div>
                        </div>
                    </div>
                    {/* Einverständniserklärung Öffentlichkeitsarbeit */}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>Einverständniserklärung Öffentlichkeitsarbeit</p>
                        </div>
                        <div className={styles.areaSpecial}>
                            <div>Hiermit erkläre ich mich einverstanden, dass Berichte/ Bilder von mir und/oder meinen Kindern, die im Rahmen von Training, Spielen oder sonstigen Veranstaltungen des TuS 05 Oberpleis e.V. für Zwecke der Öffentlichkeitsarbeit unter Beifügung des Namens auf der Vereinshomepage und/ oder den offiziellen Social-Media-Kanälen des Vereins sowie in sonstigen Publikationen (z.B. Vereinsheft, Tageszeitungen, fußball.de, etc.) genutzt und veröffentlicht werden dürfen. Dies umschließt Einzel- und Mannschaftsfotos, sowie sonstige Situationsaufnahmen. Diese Einwilligung kann jederzeit durch eine Nachricht in Textform an geschaeftsstelle@tus05-oberpleis.de oder per Brief an TuS 05 Oberpleis e.V., Humboldtstr. 3a 53639 Königswinter widerrufen werden.<span className={styles.required}>*</span></div>
                            {Object.entries(accept).map(([key, label], index) => (
                                <label key={key}>
                                    <input type="radio" name="einverstaendnisOeffentlichkeit" value={key} onChange={handleChange}
                                        required={index === 0} />
                                    {label}
                                </label>
                            ))}
                        </div>
                    </div>
                    {/* Vereinsarbeit und -entwicklung */}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>Vereinsarbeit und -entwicklung</p>
                        </div>
                        <div className={styles.areaSpecial}>
                            <p>Interesse an aktiver Vereinsarbeit im:</p>
                            {Object.entries(beteiligung).map(([key, label]) => (
                                <label key={key}>
                                    <input type="radio" name="bereich" value={label} onChange={handleChange} />
                                    {label}
                                </label>
                            ))}
                        </div>
                        <label>
                            <div>Ideen im Rahmen der Vereinsentwicklung (neue Sport-/ Freizeitangebote):</div>
                            <textarea name="ideen" placeholder="Hinweis auf bestehende Einzelmitgliedschaft, Wunsch nach Wechsel auf Familienmitgliedschaft" onChange={handleChange}></textarea>
                        </label>
                    </div>
                    {/* Gesundheitserklärung für den Jugendfußball */}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>Gesundheitserklärung für den Jugendfußball</p>
                        </div>
                        <div className={styles.areaSpecial}>
                            <p>Nach § 5 Abs. 3 der Jugendspielordnung (JSpO/WFFV mit Stand vom 01.08.2023) bestätige ich hiermit als Erziehungsberechtigte:r meines oben genannten Kindes/meiner oben genannten Kinder die sportgesundheitliche Eignung für den Fußballspiel- und Trainingsbetrieb beim TuS 05 Oberpleis e.V.. Änderungen über die Eignung teile ich dem Verein unverzüglich mit. Alternativ kann hierzu eine ärztliche Bescheinigung über die Tauglichkeit vorgelegt werden.</p>
                            {Object.entries(accept).map(([key, label]) => (
                                <label key={key}>
                                    <input type="radio" name="gesundheitJugendfussball" value={key} onChange={handleChange} />
                                    {label}
                                </label>
                            ))}
                        </div>
                    </div>
                    {/* Evaluation */}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>Evaluation</p>
                        </div>
                        <div className={styles.areaSpecial}>
                            <p>Ich habe vom TuS über ... erfahren:</p>
                            {Object.entries(evaluation).map(([key, label]) => (
                                <label key={key}>
                                    <input
                                        type="radio"
                                        name="evaluation"
                                        value={label}
                                        onChange={handleChange}
                                        checked={formData.evaluation === label}
                                    />
                                    {label}
                                </label>
                            ))}
                            <div>
                                <label>
                                    <input
                                        type="text"
                                        name="anderes"
                                        value={formData.anderes}
                                        onChange={handleChange}
                                        disabled={formData.evaluation !== "Anderes"}
                                        placeholder='Wie haben Sie von uns erfahren?'
                                        style={{
                                            backgroundColor: formData.evaluation !== "Anderes" ? '#e0e0e0' : 'white',
                                        }}
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                    <button type="submit">
                        {loading ? (
                            <>
                                <span className={styles.spinner} /> Wird gesendet...
                            </>
                        ) : (
                            "Absenden"
                        )}
                    </button>
                </form>
            ) : (
                <div className={styles.bestaetigung}>
                    <img src='/images/logo.png' alt='Logo: TuS-05-Oberpleis'></img>
                    <div className={styles.text}>
                        <p>Der Antrag zur Mitgliedschaft wurde erfolgreich übermittelt!</p>
                        <p>Sie erhalten zusätzlich eine Bestätigung per E-Mail.</p>
                    </div>
                    <img className={styles.secondImg} src='/images/logo.png' alt='Logo: TuS-05-Oberpleis'></img>
                </div>
            )}
        </section >
    )
}

export default Mitgliedschaftantrag;